import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './EnquiryConfirmed.css';

export default function EnquiryConfirmed() {
  const { id } = useParams();
  let waLink = '';
  try {
    waLink = sessionStorage.getItem('lastEnquiryWhatsAppUrl') || '';
  } catch {
    waLink = '';
  }

  return (
    <div className="enquiry-confirmed">
      <div className="confirmed-card">
        <div className="confirmed-icon">✓</div>
        <h1>Enquiry Submitted!</h1>
        <p className="confirmed-id">Enquiry ID: <strong>#{id}</strong></p>
        <p>Thank you for your interest. Our team will contact you shortly to discuss your selected items and confirm pricing.</p>
        {waLink && (
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
            style={{ marginBottom: '0.75rem' }}
          >
            Send on WhatsApp
          </a>
        )}
        <Link to="/" className="btn btn-primary">Continue Browsing</Link>
      </div>
    </div>
  );
}
